import { useEffect, useState } from 'react'
import Image from 'next/image'
import { LeadFormPDFDialog } from '~widgets/lead-form/components/lead-form-pdf-dialog'
import { cn } from '~shared/utils/cn'
import { useRouter } from 'next/router'

interface PdfFile {
  name: string
  url: string
}

interface DownloadFreeMaterialsProps {
  pdf?: PdfFile[]
  faculty?: string
}

export const DownloadFreeMaterials = ({ pdf }: DownloadFreeMaterialsProps) => {
  const router = useRouter()
  const [open, setOpen] = useState(false)
  const [isVisible, setIsVisible] = useState(true)
  const [hideByFooter, setHideByFooter] = useState(false)
  useEffect(() => {
    let footer: HTMLElement | null = null

    const updateFooter = () => {
      footer = document.querySelector('footer')
    }

    const handleScroll = () => {
      if (!footer) return
      setHideByFooter(footer.getBoundingClientRect().top <= 130)
    }

    updateFooter()
    router.events.on('routeChangeComplete', updateFooter)
    window.addEventListener('scroll', handleScroll)
    handleScroll()

    return () => {
      router.events.off('routeChangeComplete', updateFooter)
      window.removeEventListener('scroll', handleScroll)
    }
  }, [router])

  if (!isVisible) return null

  return (
    <>
      <div
        onClick={() => setOpen(true)}
        className='relative h-[200px] w-[200px] rounded-2xl bg-accent overflow-hidden text-left cursor-pointer mt-[36px] hidden lg:flex'>
        {/* декор */}
        <Image
          src='/assets/imgs/journal-page/books.png'
          width={200}
          height={200}
          alt='Книги МИТМ'
          className='object-cover absolute top-0 right-0 w-[100px]'
        />

        <div className='relative z-10 w-full p-4'>
          <button
            onClick={() => setIsVisible(false)}
            className='w-6 h-6 flex items-center justify-center rounded-full bg-[var(--alpha)] hover:opacity-70 text-black absolute left-4 top-4'
            aria-label='Закрыть'>
            ✕
          </button>

          {/* картинка книг */}

          <p className='absolute bottom-4 left-4 max-w-[120px] text-base font-medium text-white'>
            Скачать полезные материалы
          </p>
        </div>
      </div>

      <div className='lg:hidden'>
        <div
          className={cn(
            'fixed bottom-[80px] left-0 w-full transition-transform duration-500',
            // скрываем у футера
            hideByFooter ? '-translate-y-full' : 'translate-y-0'
          )}>
          <div className='container container-slim box-border my-[4px]'>
            <div className='bg-accent flex items-center justify-between px-[16px] py-[10px] rounded-[16px] gap-[8px]'>
              <span className='text-sm font-medium text-[var(--alpha)] truncate'>
                Полезные материалы
              </span>

              <div className='flex items-center gap-[8px] flex-shrink-0'>
                <button
                  onClick={() => setOpen(true)}
                  className={cn(
                    'bg-white text-accent rounded-[16px] border-0',
                    'h-[38px] px-[16px] text-[12px] font-medium leading-[120%]',
                    'flex items-center justify-center cursor-pointer',
                    'whitespace-nowrap'
                  )}>
                  скачать
                </button>
                <button
                  onClick={() => setIsVisible(false)}
                  className='bg-[var(--alpha)] text-[var(--omega)] rounded-full w-[26px] h-[26px] flex items-center justify-center text-[11px] flex-shrink-0 hover:opacity-70 border-0 cursor-pointer'
                  aria-label='Закрыть'>
                  ✕
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LeadFormPDFDialog open={open} onOpenChange={setOpen} pdf={pdf} formanaim='Новости МИТМ'/>
    </>
  )
}
